import { type Configuration, LogLevel } from '@azure/msal-browser';

/**
 * MSAL configuration for Azure AD authentication.
 *
 * Required environment variables (set via .env or deployment config):
 *   VITE_AZURE_CLIENT_ID     — Application (client) ID of the frontend SPA App Registration
 *   VITE_AZURE_API_CLIENT_ID — Application (client) ID of the backend API App Registration
 *   VITE_AZURE_TENANT_ID     — Directory (tenant) ID
 *   VITE_AZURE_REDIRECT_URI  — Redirect URI registered in the App Registration
 */

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string;
const apiClientId = import.meta.env.VITE_AZURE_API_CLIENT_ID as string;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID as string;
const redirectUri = (import.meta.env.VITE_AZURE_REDIRECT_URI as string) ?? window.location.origin;

if (!clientId || !apiClientId || !tenantId) {
  throw new Error(
    '[OptiBush Auth] Missing required environment variables: VITE_AZURE_CLIENT_ID, VITE_AZURE_API_CLIENT_ID and VITE_AZURE_TENANT_ID must be set.',
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes requested during login / token acquisition.
 * Resource is the API app's own client ID - a separate App Registration from the SPA.
 */
export const loginRequest = {
  scopes: [`api://${apiClientId}/access_as_user`],
};

/**
 * Scopes for the backend API token acquisition (silent).
 */
export const apiTokenRequest = {
  scopes: [`api://${apiClientId}/access_as_user`],
};
